"use client";

import { Navbar, Dropdown, Avatar, Badge } from "flowbite-react";
import { Link, useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";





const Header = ({ user }) => {
  const navigate = useNavigate();

  const gotoMyExpenses = () => navigate('/expense/expenses/'+encodeURI(JSON.stringify({self: user.id})));
  const gotoMyExpensesToSubmit = () => navigate('/expense/expenses/'+encodeURI(JSON.stringify({self: user.id, filter: 'to_submit'})));

  return (
    <Navbar fluid rounded className="mb-3 border-b-2 py-1 pb-0 header">
      <div className="flex">
        <Link className="me-3 p-2 border-2 rounded hover:text-blue-500" to={'/'}>{<MdDashboard />}</Link>
        <Navbar.Brand as={Link} to={'/expense'} className="w-50">
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Expenses</span>
        </Navbar.Brand>
      </div>
      <div className="flex">

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">My Expenses</span>}>
          <Dropdown.Item as={Link} to={'/expense/expenses/option/'+encodeURI(JSON.stringify(['my_expenses', 'to_submit']))}>My Expense to Submit</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/expense/expenses/option/'+encodeURI(JSON.stringify(['my_expenses']))}>All My Expenses</Dropdown.Item>
          {/* <Dropdown.Item as={Link} to={'/expense'}>My Reports</Dropdown.Item> */}
        </Dropdown>


        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Expense Reports</span>}>
          <Dropdown.Item as={Link} to={'/sales/to-invoice'}>Reports to Approve</Dropdown.Item>
          {/* <Dropdown.Item as={Link} to={'/sales/packages'}>Report to Post</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/sales/packages'}>Report to Pay</Dropdown.Item> */}
          <Dropdown.Item as={Link} to={'/sales/packages'}>All Reports</Dropdown.Item>
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Reporting</span>}>
          <Dropdown.Item as={Link} to={'/expense'}>Expense Analysis</Dropdown.Item>
          {/* <Dropdown.Item as={Link} to={'/sales/packages'}>Product Variants</Dropdown.Item> */}
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Configurations</span>}>
          <Dropdown.Item as={Link} to={'/expense/settings'}>Settings</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/expense/approve-limits'}>Approve Limit</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/expense/petty-cash'}>Petty Cash</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/expense/expense-categories'}>Expense Categories</Dropdown.Item>

        </Dropdown>
      </div>
      <div className="">
        
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded />
          }
        >
          <Dropdown.Header>
            <span className="block text-sm">Bonnie Green</span>
            <span className="block truncate text-sm font-medium">name@flowbite.com</span>
          </Dropdown.Header>
          <Dropdown.Item>Dashboard</Dropdown.Item>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item>Earnings</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>Sign out</Dropdown.Item>
        </Dropdown>
        {/* <Navbar.Toggle /> */}
      </div>
      {/* <Navbar.Collapse>
        <Navbar.Link href="#" active>
          Home
        </Navbar.Link>
        <Navbar.Link href="#">About</Navbar.Link>
        <Navbar.Link href="#">Services</Navbar.Link>
        <Navbar.Link href="#">Pricing</Navbar.Link>
        <Navbar.Link href="#">Contact</Navbar.Link>
      </Navbar.Collapse> */}
    </Navbar>
  );
}




export default Header;